export const MembersColumnsWithDelete = [
    {
        Header: 'Name',
        accessor: 'name',
    },
    {
        Header: 'Level',
        accessor: 'level'
    },
    {
        Header: 'TCR',
        accessor: 'tcr'
    },
    {
        Header: 'Profile'
    },
    {
        Header: 'Delete'
    }
]
